exports.default = "<div class=\"basepagelayout-content\"> <div class=\"we_container\"> <div class=\"instabilityMessages_content\"> </div> </div> </div>";